import React from 'react'
import { useTranslation } from 'react-i18next'
import { CardEmptyState } from 'ui_elements/CardEmptyState/CardEmptyState'
import EmptyProductDatabase from 'icons/svg/empty-product-database.svg'

export const GlobalSearchEmptyState = () => {
  const { t } = useTranslation('global_search')

  return (
    <CardEmptyState
      header={t('global_search:EmptyState.header', 'Scouting for something?')}
      imageUrl={EmptyProductDatabase}
      horizontal={false}
      message={t(
        'global_search:EmptyState.message',
        'Type a keyword and we’ll search through content, features, ASINs, and settings.'
      )}
    />
  )
}
